export default "__VITE_ASSET__DvUW7mQ7__"